import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { RootState, AppDispatch } from '../redux/store';
import { verifyAlbum, shareAlbum } from '../redux/thunks/albumThunks';
import Navbar from './navbar';

const albumCategories = [
    { category: "Wedding Memories", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/marriage.png" },
    { category: "Birthday Celebrations", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/birthday.png" },
    { category: "Baby Shower & Newborn", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/nb.png" },
    { category: "Graduation Moments", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/graduation.png" },
    { category: "Anniversary Specials", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/anniversary.png" },
    { category: "Family Gatherings & Reunions", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/familyGatherings.png" },
    { category: "Holiday & Festival Fun", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/fastival.png" },
    { category: "Travel & Adventures", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/travel%26adventures.png" },
    { category: "Corporate Events & Conferences", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/corporate.png" },
    { category: "Farewell & Retirement Parties", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/farewell.png" },
    { category: "default", url: "https://storage.googleapis.com/heartfelt-6a946.firebasestorage.app/Album-defalut/default-album.jpg" }
];

const getThumbnailFromCategory = (category: string) => {
    const found = albumCategories.find(c => c.category === category);
    return found ? found.url : albumCategories.find(c => c.category === 'default')?.url;
};

const ShareAlbum: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { albumId, userId } = useParams<{ albumId: string; userId: string }>();
    const [album, setAlbum] = useState<{
        title: string;
        thumbnail: string;
        description: string;
        createdBy: string;
        likes: number;
        verified: boolean;
        status: string;
        sharedBy: string;
    } | null>(null);
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state.auth.user);
    const albumState = useSelector((state: RootState) => state.albums);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmited, setIsSubmited] = useState(false);

    useEffect(() => {
        const fetchAlbum = async () => {
            if (albumId && userId) {
                // if (!userId || !album) navigate(`/auth?redirect=login`);
                try {
                    const resultAction = await dispatch(verifyAlbum({ albumId, verifyId: userId }));
                    if (verifyAlbum.fulfilled.match(resultAction)) {
                        const data = resultAction.payload;
                        // console.log('Verified Album Data:', data);
                        setAlbum(data);
                    } else {
                        console.error('Failed to verify album');
                    }
                } catch (error) {
                    console.error('Error verifying album:', error);
                }
            }
        };

        fetchAlbum();
    }, [albumId, userId, dispatch]);

    const handleAddAlbum = async () => {
        if (album && userId) {
            setIsSubmitting(true);
            setErrorMessage('');
            try {
                const result = await dispatch(shareAlbum({ albumId, userId }));
                if (shareAlbum.fulfilled.match(result)) {
                    setIsSubmited(true);
                    setErrorMessage('');
                } else {
                    console.log(result)
                    const errorMsg = typeof result.payload === 'string'
                        ? result.payload
                        : 'Failed to add album. Please try again.';
                    setErrorMessage(errorMsg);
                }
            } catch (error) {
                console.error("Error sharing album:", error);
                setErrorMessage('Something went wrong. Please try again later.');
            } finally {
                setIsSubmitting(false);
            }
        }
    };    

    return (
        <div className="min-h-screen bg-black text-white flex flex-col">
            <Navbar navLight={false} playBtn={false} bgLight={false} navCenter={true} />

            <div className="flex flex-1 items-center justify-center">
                {isSubmited ? (
                    <div className="text-green-400 text-center text-base sm:text-lg font-semibold mb-6 sm:mb-8 px-4 flex flex-col items-center gap-4">
                        ✅  Album added successfully!
                        <button
                            onClick={() => navigate('/dashboard')}
                            disabled={isSubmitting}
                            className={`${
                                isSubmitting
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : 'bg-green-600 hover:bg-green-700'
                            } text-white font-semibold py-2 px-6 rounded-md w-full sm:w-auto transition-all duration-200`}
                        >
                            Back to Dashboard
                        </button>
                    </div>
                ) : errorMessage ? (
                    <div className="text-red-500 text-center text-base sm:text-lg font-semibold mb-6 sm:mb-8 px-4 flex flex-col items-center gap-4">
                        ❌ {errorMessage}
                        <button
                            onClick={() => navigate('/dashboard')}
                            disabled={isSubmitting}
                            className={`${
                                isSubmitting
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : 'bg-green-600 hover:bg-green-700'
                            } text-white font-semibold py-2 px-6 rounded-md w-full sm:w-auto transition-all duration-200`}
                        >
                            Back to Dashboard
                        </button>
                    </div>
                ) :  album ? (
                    <div className="bg-gray-900 p-8 rounded-xl shadow-lg max-w-3xl w-full text-left">
                        <img
                            src={getThumbnailFromCategory(album.thumbnail)}
                            alt={album.title}
                            className="w-full h-40 object-cover transition duration-300 group-hover:blur-sm"
                        />
                        <h1 className="text-3xl font-bold text-white text-center mb-8">{album.title}</h1>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-4">
                            <p className="text-lg text-gray-400">
                                <span className="font-semibold text-white">Description:</span> {album.description}
                            </p>
                            <p className="text-lg text-gray-400">
                                <span className="font-semibold text-white">Shared By:</span> {album.sharedBy}
                            </p>
                            <p className="text-lg text-gray-400">
                                <span className="font-semibold text-white">Likes:</span> {album.likes}
                            </p>
                            <p className="text-lg text-gray-400">
                                <span className="font-semibold text-white">Verified:</span> {album.verified ? 'Yes' : 'No'}
                            </p>
                        </div>

                        <div className="text-center mt-8">
                            <button
                                onClick={handleAddAlbum}
                                disabled={isSubmitting}
                                className={`${
                                    isSubmitting ? 'bg-gray-500 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
                                } text-white font-semibold py-2 px-6 rounded-lg`}
                            >
                                {isSubmitting ? 'Adding...' : 'Add Album'}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="text-gray-400 text-center">Loading album details...</div>
                )}

            </div>
        </div>
    );


};

export default ShareAlbum;
